import { Navigate, useParams } from "react-router";

/** Short-path alias: /news → /hub/news */
export function RedirectToHubNews() {
  const { section } = useParams();
  return <Navigate to={section ? `/hub/news/${section}` : "/hub/news"} replace />;
}

/** Short-path alias: /resources → /hub/resources */
export function RedirectToHubResources() {
  const { category } = useParams();
  return (
    <Navigate
      to={category ? `/hub/resources/${category}` : "/hub/resources"}
      replace
    />
  );
}

/** Short-path alias: /guides → /hub/guides */
export function RedirectToHubGuides() {
  const { topicSlug, journeySlug } = useParams();
  const parts = ["/hub/guides"];
  if (topicSlug) parts.push(topicSlug);
  if (journeySlug) parts.push(journeySlug);
  return <Navigate to={parts.join("/")} replace />;
}

/** Short-path alias: /uni-sport → /hub/uni-sport */
export function RedirectToHubUniSport() {
  const { sportId, tab } = useParams();
  if (!sportId) return <Navigate to="/hub/uni-sport" replace />;
  const base = `/hub/uni-sport/${sportId}`;
  return <Navigate to={tab ? `${base}/${tab}` : base} replace />;
}

/** Short-path alias: /uni-sport/rankings → /hub/uni-sport/rankings */
export function RedirectToHubUniSportRankings() {
  return <Navigate to="/hub/uni-sport/rankings" replace />;
}
